import { isEmpty } from '@ember/utils'
import type { NormalizedInterval } from 'date-fns'
import type { SchoolScope, StudentsScope } from 'teacher-ui-client/reporting/ui-scope/utils'
import type StudentEventsService from 'teacher-ui-client/services/student-events'
import fillMonths from 'teacher-ui-client/utils/student-events/fill-months'

export interface TotalUsageOverTimeResponse {
  total_usage_over_time_summary: { category: string; event_count: number; student_count: number }[]
  total_usage_over_time_by_month: { category: string; months: { month: string; count: number }[] }[]
}

export interface TotalUsageOverTimeDataItem {
  category: string
  event_count: number
  student_count: number
  months: { month: string; count: number }[]
}

export async function totalUsageOverTime(
  this: StudentEventsService,
  product: LegacyProductRe | LegacyProductRex | LegacyProductMs | LegacyProductFp,
  statsScope: SchoolScope | StudentsScope,
  period: NormalizedInterval,
): Promise<Nullable<TotalUsageOverTimeDataItem[]>> {
  if (isEmpty(statsScope.ids)) return null

  const url = this.buildUrl('total_usage_over_time', product, statsScope)
  const query = this.buildQuery(statsScope, period)

  const data = await this.fetchData<TotalUsageOverTimeResponse>(url, query)
  if (!data) return null

  const { total_usage_over_time_summary: summaryData, total_usage_over_time_by_month: monthData } = data
  const emptyData = monthData.every((category) => category.months.length === 0)
  if (emptyData || monthData.length === 0) return null

  return summaryData
    .map((categorySummary) => {
      const months = monthData.find((monthData) => monthData.category === categorySummary.category)?.months
      if (!months) return null

      return {
        category: categorySummary.category,
        event_count: categorySummary.event_count,
        student_count: categorySummary.student_count,
        months: fillMonths(months, period, { count: 0 }),
      }
    })
    .filter((data) => data !== null)
}
